import React from 'react';
import { StarIcon } from 'lucide-react';
import { reviews } from '../data/content';
export function Testimonials() {
  const [featured, ...rest] = reviews;
  return <section className="w-full bg-cream py-16 sm:py-20" aria-labelledby="reviews-heading" data-id="element-231" data-mp="3ksqgpam7bm8l">
      <div className="mx-auto max-w-6xl px-5" data-id="element-232" data-mp="3fxkx4ig9ujno">
        <div className="flex flex-wrap items-end justify-between gap-4" data-id="element-233" data-mp="3b1chl3y5wofz">
          <div data-id="element-234" data-mp="36yppd1xkx1i9">
            <p className="font-sans text-xs font-bold uppercase tracking-[0.24em] text-gold" data-id="element-235" data-mp="36z97ojr55rwt">
              Trusted by stylists worldwide
            </p>
            <h2 id="reviews-heading" className="mt-4 font-display text-3xl font-semibold leading-tight tracking-tight text-espresso sm:text-4xl" data-id="element-236" data-mp="321za2gtlm9xw">
              What stylists are saying
            </h2>
          </div>
          <p className="flex items-center gap-2 font-sans text-sm font-semibold text-cocoa" data-id="element-237" data-mp="v8dn3qgaqkei">
            <span className="flex" aria-hidden="true" data-id="element-238" data-mp="qbetd90jofgu">
              {[0, 1, 2, 3, 4].map(i => <StarIcon key={i} className="h-4 w-4 fill-gold text-gold" data-id="element-239" data-mp="h4wuw2gayci7" />)}
            </span>
            4.9/5 · 5,000+ stylists
          </p>
        </div>

        <div className="mt-10 grid gap-6 md:grid-cols-2 lg:grid-cols-3" data-id="element-240" data-mp="780kfr6ufgb0">
          <figure className="flex h-full flex-col rounded-2xl bg-espresso p-8 text-cream md:col-span-2" data-id="element-241" data-mp="7a4xaympzpnf">
            <blockquote className="flex-1 font-display text-2xl font-semibold leading-snug sm:text-3xl" data-id="element-242" data-mp="c8oiuxxeizf9">
              “{featured.text}”
            </blockquote>
            <figcaption className="mt-7 flex items-center gap-3 border-t border-cream/15 pt-5" data-id="element-243" data-mp="14uzlee4kjaep">
              <span className="flex h-11 w-11 items-center justify-center rounded-full bg-gold font-sans text-sm font-bold text-espresso" data-id="element-244" data-mp="q63famm2o7gq">
                {featured.initials}
              </span>
              <span className="font-sans text-sm text-cream/70" data-id="element-245" data-mp="1iuihu9o0oxb6">
                <span className="font-bold text-cream" data-id="element-246" data-mp="1nmk1whrffsbr">{featured.name}</span> ·{' '}
                {featured.role} · {featured.city}
              </span>
            </figcaption>
          </figure>

          {rest.map(review => <figure key={review.name} className="flex h-full flex-col rounded-2xl border border-espresso/10 bg-sand p-7" data-id="element-247" data-mp="1sk7gcf0a0xxb">
              <blockquote className="flex-1 font-sans text-base leading-relaxed text-cocoa" data-id="element-248" data-mp="1jir7ibp413v7">
                “{review.text}”
              </blockquote>
              <figcaption className="mt-6 flex items-center gap-3 border-t border-espresso/10 pt-5" data-id="element-249" data-mp="1ekfyu4ajwzek">
                <span className="flex h-10 w-10 items-center justify-center rounded-full bg-espresso font-sans text-xs font-bold text-cream" data-id="element-250" data-mp="19r3j6jnuo2xy">
                  {review.initials}
                </span>
                <span className="font-sans text-sm text-muted" data-id="element-251" data-mp="10pnbijof6exf">
                  <span className="font-bold text-espresso" data-id="element-252" data-mp="vrlt80ytijn0">{review.name}</span> ·{' '}
                  {review.role} · {review.city}
                </span>
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}